import { useState } from "react";
import HalfScreenContainer from "../../../components/HalfScreenContainer";
import TeacherRegisterForm, {
  TeacherRegisterFormFields,
} from "./TeacherRegisterForm";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useUserApi } from "../../../apis/user.api";

function Register() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { register } = useUserApi();

  const onSubmit = async ({
    email,
    password,
    name,
    lastname,
  }: TeacherRegisterFormFields) => {
    setIsLoading(true);
    try {
      await register({
        email,
        password,
        name,
        lastname,
      });
    } finally {
      setIsLoading(false);
    }
    navigate("/login");
  };

  return (
    <HalfScreenContainer
      hasNav={false}
      className={classNames({ "pointer-events-none": isLoading })}
    >
      <HalfScreenContainer.ContentLeft className="flex-col items-center justify-center bg-th-secondary-900">
        <div className="">
          <span className="font-bold uppercase text-white">Registrieren</span>
          <h1 className="text-white">Willkommen bei Nidesso!</h1>
        </div>
      </HalfScreenContainer.ContentLeft>
      <HalfScreenContainer.ContentRight className="my-auto space-y-4 p-20 md:p-40">
        <h1 className="text-th-primary-900 lg:hidden">Registrieren</h1>
        <TeacherRegisterForm onSubmit={onSubmit}></TeacherRegisterForm>
      </HalfScreenContainer.ContentRight>
    </HalfScreenContainer>
  );
}

export default Register;
